import { featureRequirements } from "../../constants";

export const getValidFeatures = (currentFeatures) => {
  const invalidFeatures = currentFeatures.filter((feature) => {
    const requirements = featureRequirements[feature];
    if (!requirements) return false; // feature is valid if no requirements

    if ("or" in requirements)
      return !requirements.or.some((req) => currentFeatures.includes(req));

    if ("and" in requirements)
      return !requirements.and.every((req) => currentFeatures.includes(req));

    return true; // invalid if requirements object is empty
  });

  if (invalidFeatures.length === 0) return currentFeatures; // if all features are valid, we're done

  // Remove invalid features and recursively check again
  const newFeatures = currentFeatures.filter(
    (f) => !invalidFeatures.includes(f)
  );
  return getValidFeatures(newFeatures);
};
